import React, { useEffect, useRef, useState } from 'react'
import { UpOutlined, DownOutlined } from '@ant-design/icons'
import Switch from './Switch'
import {
  City,
  Center,
  defaultCoordinates,
  SetState,
} from '../../../types/AddressesGroup'
import { MapRef } from 'react-map-gl'
import { getGeoCenter, mapGoTo } from '../functions'

interface CitiesProps {
  cities: City[]
  selectedCity: City | undefined
  setSelectedCity: SetState<City | undefined>
  isCorporation: boolean
  setIsCorporation: SetState<boolean>
  isTopCfe: boolean
  setIsTopCfe: SetState<boolean>
  mapRef: MapRef | null
  setCurrentPage: SetState<number>
  centers: Center[]
  setWaitForMvt: SetState<boolean>
  defaultCoordinates: defaultCoordinates
  isBe: boolean
  isMobile: boolean
  currentCountry: string
}

const CitiesFilter = ({
  cities,
  selectedCity,
  setSelectedCity,
  setIsCorporation,
  setIsTopCfe,
  isTopCfe,
  mapRef,
  setCurrentPage,
  centers,
  setWaitForMvt,
  defaultCoordinates,
  isBe,
  isMobile,
  currentCountry,
}: CitiesProps): JSX.Element => {
  const wrapperRef = useRef<HTMLInputElement>(null)
  const [openDropdown, setOpenDropdown] = useState(false)
  let citiesFilterToDisplay
  if (window.innerWidth > 1200) {
    citiesFilterToDisplay = cities.slice(0, 9)
  } else if (window.innerWidth > 965) {
    citiesFilterToDisplay = cities.slice(0, 7)
  } else {
    citiesFilterToDisplay = cities.slice(0, 5)
  }

  const handleCityClick = (city: City) => {
    if (selectedCity?.id === city.id) {
      setSelectedCity(undefined)
      mapGoTo(defaultCoordinates, mapRef, defaultCoordinates.zoom)
    } else if (city.name.toLowerCase() === 'ile-de-france') {
      mapGoTo(getGeoCenter(centers, city), mapRef, 8.75)
      setWaitForMvt(true)
      setSelectedCity(city)
    } else {
      mapGoTo(getGeoCenter(centers, city), mapRef, 10.5)
      setWaitForMvt(true)
      setSelectedCity(city)
    }
    setCurrentPage(1)
  }

  const ClickOutsideAlerter = (ref: React.RefObject<HTMLInputElement>) => {
    useEffect(() => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const handleClickOutside = (e: any) => {
        if (ref.current && !ref.current.contains(e.target)) {
          setOpenDropdown(false)
        }
      }
      document.addEventListener('mousedown', handleClickOutside)
      return () => document.removeEventListener('mousedown', handleClickOutside)
    }, [ref])
  }
  ClickOutsideAlerter(wrapperRef)

  return (
    <div className="sticky-cities-filter">
      <div className="section by-1 py-0">
        <div className="is-flex container">
          <div className="is-flex is-align-items-center p-1 cities-filter-mobile">
            {citiesFilterToDisplay.map((city: City) => {
              return (
                <a
                  key={city.id}
                  className={`button is-tiny is-light-blue has-text-weight-medium mr-1 is-hidden-mobile ${
                    selectedCity?.id === city.id && 'is-active'
                  }`}
                  onClick={() => handleCityClick(city)}
                  href={selectedCity?.id === city.id ? `#${city.slug}` : '#'}
                >
                  {city.name}
                </a>
              )
            })}

            {(cities.length > 6 || isMobile) && (
              <div
                ref={wrapperRef}
                className={`dropdown ${openDropdown && 'is-active'}`}
                onClick={() => setOpenDropdown(!openDropdown)}
              >
                <div className="dropdown-trigger">
                  <button
                    aria-haspopup="true"
                    aria-controls="dropdown-menu"
                    className="button is-tiny is-light-blue has-text-weight-medium"
                  >
                    Plus de villes &#8239;
                    {openDropdown ? (
                      <UpOutlined className="ml-1" />
                    ) : (
                      <DownOutlined className="ml-1" />
                    )}
                  </button>
                </div>
                <div className="dropdown-menu">
                  <div className="dropdown-content">
                    {cities.map((city: City) => {
                      return (
                        <a
                          className={`dropdown-item ${
                            selectedCity?.id === city.id &&
                            'cities-filter-dropdown'
                          }`}
                          key={city.id}
                          onClick={() => handleCityClick(city)}
                          href={
                            selectedCity?.id === city.id ? `#${city.slug}` : '#'
                          }
                        >
                          {city.name}
                        </a>
                      )
                    })}
                  </div>
                </div>
              </div>
            )}
          </div>
          {!isBe && (
            <div className="is-flex is-align-items-center bl-1 p-1 cfe-filter">
              <div
                className={`button is-tiny is-light-blue has-text-weight-medium cities-filter-full-width ${
                  isTopCfe && 'is-active'
                }`}
                onClick={() => setIsTopCfe(!isTopCfe)}
              >
                Filtrer par CFE
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="section bb-1 py-0">
        <div className="is-flex container types-container">
          <Switch
            setIsCorporation={setIsCorporation}
            currentCountry={currentCountry}
          />
        </div>
      </div>
    </div>
  )
}

export default CitiesFilter
